import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { MembershipTypeReferenceModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: 'root'
})
export class MembershipTypeReferenceService extends ApiServiceBase {
    private readonly REFERENCE_PATH = '/airline/MembershipTypeReferences';
    constructor(
        httpClient: HttpClient,
        authService: AuthService
    ) {
        super(httpClient, authService);
    }

    public getMembershipTypeReferences(): Observable<MembershipTypeReferenceModel[]> {
        return this.httpGet<MembershipTypeReferenceModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}